import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "../../../components/dashboard-layout/layout";
import ViewDetailsComponent, {
  TopicType,
  ViewTopic,
} from "../../../components/view-details.component";
import {
  AlertType,
  useDashboardStore,
} from "../../dashboard/store/dashboard.store";
import { getEndPageById } from "../apis/end-page.api";
import DeletePastPageDialog from "../dialogs/delete-end-page.dialog";
import EditPastPageDialog from "../dialogs/edit-end-page.dialog";
import { EndPageDetailsEntity } from "../entities/end-page-details.entity";
import { EndPageDetailsModel } from "../models/end-page-details.model";

const topics: ViewTopic[] = [
  {
    title: "Cover Image",
    contentKey: "imageUrl",
    type: TopicType.image,
  },
  {
    title: "Description",
    contentKey: "description",
    type: TopicType.string,
  },
  {
    title: "Created At",
    contentKey: "createdAt",
    type: TopicType.dateTime,
  },
  {
    title: "Last Update",
    contentKey: "updatedAt",
    type: TopicType.dateTime,
  },
];

export default function ViewEndPage() {
  const [searchParams] = useSearchParams();
  const [endPage, setEndPage] = useState<EndPageDetailsEntity>();
  const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  const initEffect = useRef<boolean>(false);
  const setAlert = useDashboardStore((state) => state.setAlert);

  useEffect(() => {
    if (initEffect.current === false) {
      const id = searchParams.get("id");
      if (id) {
        getEndPageById(id)
          .then((response) => {
            const newPastPage = new EndPageDetailsModel(
              response.data
            ).toEntity();
            setEndPage(newPastPage);
          })
          .catch((error) => {
            setAlert({
              message: error.response.data.message,
              type: AlertType.error,
            });
          });
      }
    }
    return () => {
      initEffect.current = true;
    };
  }, [searchParams, setAlert]);

  return (
    <Layout>
      {endPage && (
        <EditPastPageDialog
          open={editModalOpen}
          setOpen={setEditModalOpen}
          endPage={endPage}
        />
      )}
      {endPage && (
        <DeletePastPageDialog
          open={deleteModalOpen}
          setOpen={setDeleteModalOpen}
          endPage={endPage}
        />
      )}
      <div className="flex">
        <div className="flex-grow px-4 sm:px-0">
          <h3 className="text-base font-semibold leading-7 text-gray-900">
            End Page Details
          </h3>
        </div>
        <button
          className="mx-1 rounded-md bg-indigo-600 px-3 py-1.5 text-center text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={() => setEditModalOpen(true)}
        >
          Edit
        </button>
        <button
          className="mx-1 rounded-md bg-red-600 px-3 py-1.5 text-center text-sm font-semibold leading-6 text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={() => setDeleteModalOpen(true)}
        >
          Delete
        </button>
      </div>

      {endPage && <ViewDetailsComponent topics={topics} content={endPage} />}
    </Layout>
  );
}
